import React, {useEffect, useState} from 'react'
import {Box, CircularProgress, Typography} from '@mui/material'
import {useTheme} from '@mui/material/styles'
import apiClient from 'src/services/apiClient'
import {STATUS} from 'src/constants/constants'
import Card from 'src/components-new/layout/Card'
import {NEUTRAL_SCALE} from 'src/theme-new/tokens'
import {Program} from './types'

interface ProgramCardProps {
  program: Program
  href: string
}

export default function ProgramCard({program, href}: ProgramCardProps): JSX.Element {
  const theme = useTheme()
  const [logoBase64, setLogoBase64] = useState('')
  const [status, setStatus] = useState<string>()

  useEffect(() => {
    const fetchProgramImage = async () => {
      if (program?.logoFileService?.file) {
        const logo = await apiClient.getProgramImage(program.logoFileService.file, setStatus)
        setLogoBase64(logo ?? '')
      }
    }
    fetchProgramImage()
  }, [program?.logoFileService?.file])

  return (
    <Box component="a" href={href} sx={{display: 'block', textDecoration: 'none', color: 'inherit'}}>
      <Card
        sx={{
          cursor: 'pointer',
          height: '100%',
          transition: 'border-color 0.15s ease',
          '&:hover': {borderColor: theme.palette.primary.main},
        }}
      >
        <Box sx={{p: 0}}>
          <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 150}}>
            {program?.logoFileService?.file && (status === undefined || status === STATUS.PENDING) ? (
              <CircularProgress size={28} />
            ) : program?.logoFileService?.file && status === STATUS.FULFILLED ? (
              <Box
                component="img"
                alt={program?.scope ?? ''}
                src={`data:image/png;base64,${logoBase64}`}
                sx={{maxHeight: 150, maxWidth: '100%', objectFit: 'contain'}}
              />
            ) : null}
          </Box>
          <Box sx={{pt: 2, borderTop: `1px solid ${NEUTRAL_SCALE[100]}`, textAlign: 'center'}}>
            <Typography sx={{fontWeight: 600, fontSize: 18, color: NEUTRAL_SCALE[900], mb: 0.5}}>
              {`Portale programma ${program?.name ?? ''}`}
            </Typography>
            <Typography variant="body2" sx={{color: NEUTRAL_SCALE[500]}}>
              Portale di programma supporto paziente
            </Typography>
          </Box>
        </Box>
      </Card>
    </Box>
  )
}
